import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/system';
import { useTranslation, Trans } from 'next-i18next';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useWatch } from 'react-hook-form-mui';
import { useMutation } from '@apollo/client';
import { graphql } from '@/gql';
import { Link, Typography } from '@mui/material';
import useExtendedSnackbar from '@/hooks/useExtendedSnackbar';
import { getErrorMessageFromApolloError } from '@/graphql/helpers';

const FORGOTTEN_PASSWORD = graphql(/* GraphQL */ `
    mutation forgottenPassword($username: String!) {
        forgottenPassword(username: $username)
    }
`);

export default function ForgotPasswordButton() {
    const [forgotPasswordClicked, setForgotPasswordClicked] = useState(false);
    const { username } = useWatch();
    const { t } = useTranslation('common');

    const { enqueueErrorSnackbar } = useExtendedSnackbar();

    const [forgottenPasswordMutate, { loading }] = useMutation(
        FORGOTTEN_PASSWORD,
        {
            onError: (error) => {
                enqueueErrorSnackbar(getErrorMessageFromApolloError(error));
            },
        },
    );

    useEffect(() => {
        if (forgotPasswordClicked) {
            setForgotPasswordClicked(false);
        }
    }, [username]);

    const usernameFilled = useMemo(
        () => username != null && username !== '',
        [username],
    );

    const forgotPasswordButtonOnClick = useCallback(() => {
        setForgotPasswordClicked(true);
        forgottenPasswordMutate({ variables: { username } });
    }, [username]);

    return (
        <Box sx={{ marginTop: '1.5rem' }}>
            <Typography sx={{ fontWeight: 600 }}>
                <Trans i18nKey="login.forgotPassword" ns="common">
                    <Link
                        onClick={forgotPasswordButtonOnClick}
                        sx={{
                            cursor: 'pointer',
                            color: '#D94D4A',
                            textDecorationColor: '#D94D4A',
                        }}
                    />
                </Trans>
            </Typography>

            {forgotPasswordClicked && !loading && (
                <Box mt={2}>
                    <Alert severity={usernameFilled ? 'success' : 'error'}>
                        {usernameFilled
                            ? t('login.forgotPasswordEmailSent')
                            : t('login.forgotPasswordNotPossible')}
                    </Alert>
                </Box>
            )}
        </Box>
    );
}
